module.exports = __webpack_public_path__ + "img/settings_brightness.9a742e01.svg";